import { inject, Injectable } from '@angular/core';
import { EncryptionDecryptionService } from './EncryptionDecryption.service';

@Injectable({
    providedIn: 'root',
})
export class SessionStorageService {

    protected serviceED: EncryptionDecryptionService = inject(EncryptionDecryptionService);

    // Establecer elemento en el almacenamiento local 
    setItem(key: string, value: any): void {
        try {
            const jsonValue = JSON.stringify(value);
            const ValueCrypted = this.serviceED.Encryption(jsonValue);
            sessionStorage.setItem(key, ValueCrypted);
        } catch (_error) {
            const errorMessage = _error instanceof Error ? _error.message : String(_error);
            console.error('Error al guardar en el almacenamiento local', errorMessage);
        }
    }
    // Obtener elemento del almacenamiento local
    getItem<T>(key: string): T | null {
        const encryptedValue = sessionStorage.getItem(key);
        if (!encryptedValue) return null;
        try {
            const ValueDeCrypted = this.serviceED.Decryption(encryptedValue);
            return ValueDeCrypted ? JSON.parse(ValueDeCrypted) : null;
        } catch (_error) {
            const errorMessage = _error instanceof Error ? _error.message : String(_error);
            console.error('Error al descifrar los datos', errorMessage);
            return null;
        }
    }
    // Eliminar elemento del almacenamiento local 
    removeItem(clave: string): void {
        sessionStorage.removeItem(clave);
    }
    // Borrar todo el almacenamiento local 
    clear(): void {
        sessionStorage.clear();
    }
}